var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageExchange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0145 32.9127C70.1654 31.7234 72.0625 31.6923 73.2518 32.8433L92.3375 51.3132C93.2149 52.1623 93.4894 53.4588 93.0314 54.5907C92.5734 55.7225 91.4745 56.4633 90.2535 56.4633H32.9967C31.3417 56.4633 30 55.1216 30 53.4666C30 51.8116 31.3417 50.4699 32.9967 50.4699H82.8478L69.0839 37.1501C67.8947 35.9991 67.8636 34.102 69.0145 32.9127Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0835 90.2042C54.9326 91.3935 53.0354 91.4246 51.8461 90.2737L32.7605 71.8037C31.8831 70.9546 31.6086 69.6581 32.0666 68.5263C32.5246 67.3944 33.6235 66.6537 34.8445 66.6537L92.1013 66.6537C93.7563 66.6537 95.098 67.9953 95.098 69.6503C95.098 71.3053 93.7563 72.647 92.1013 72.647L42.2502 72.647L56.014 85.9669C57.2033 87.1178 57.2344 89.0149 56.0835 90.2042Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 62,
    y1: 0,
    x2: 62,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37B06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#199251"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageExchange);
export default __webpack_public_path__ + "static/media/page-exchange.f51ff4d7962a7d2295a7708a81765bac.svg";
export { ForwardRef as ReactComponent };